import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './css/WelcomeMessage.css';
import JWTErrorPopup from './JWTErrorPopup'; // Import the popup component
import { handleJWTResponse } from './jwtErrorHandler'; 


function CurrencyPage() {
    // const [billingEntities, setBillingEntities] = useState([]);
    // const [selectedEntityId, setSelectedEntityId] = useState(null);
    // const navigate = useNavigate();

    const location = useLocation();
    const navigate = useNavigate();

    // Extract state from the location prop (coming from OptionsPage)
    const { firmId, firmName, accountId, email } = location.state || {};

    
    const [currencies, setCurrencies] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [showJWTError, setShowJWTError] = useState(false);
        const [jwtErrorMessage, setJwtErrorMessage] = useState('');
    
        const closeJWTErrorPopup = () => {
            setShowJWTError(false);
            navigate('/firm');
        };


    useEffect(() => {
        // Only fetch if firmId is available
        if (firmId) {
            // Fetch Billing Entities from the backend
            fetch(`https://cloud9requests.symphony.com/requests/api/getBillingEntities`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ firm_id: firmId })
            })
                .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
                .then((data) => {
                    const currencyCodes = data.records.map(entity => entity.CurrencyIsoCode);
                    const uniqueCurrencies = [...new Set(currencyCodes)];
                    setCurrencies(uniqueCurrencies);
                })
                .catch(error => {
                    if (error.message !== "JWT error handled") {
                        console.error('Error fetching Currency/Entities:', error);
                    }
                });
        }
    }, [firmId]); 

    const handleEntityChange = (event) => {
        setSelectedCurrency(event.target.value);
        //console.log(event.target.value);
    };

    const handleNext = () => {
       
        navigate('/optionsPage', {
            state: { firmName, selectedCurrency, firmId, accountId, email }
        });
    };

    return (
        <div>
                         {/* JWT Error Popup */}
                         {showJWTError && (
                            <JWTErrorPopup 
                                message={jwtErrorMessage} 
                                onClose={closeJWTErrorPopup} 
                            />
                        )}
           <button onClick={() => {
                navigate('/accountsPage', {
                    state: { 
                        email
                    }
            });
        }}
    className="back-link"
>
    Back
</button>
           
            <div className="opportunity-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img src="https://cloud9requests.symphony.com/Cloud9_Logo.png" alt="C9 Logo" width="300" height="100"></img>
                {/* <h2>Welcome, please fillout the form to add a user.</h2> */}
                <h2>Firm Name : {firmName}!</h2>
                <h2>Select a Currency</h2>
                <label>Select a Currency</label>
                <select value={selectedCurrency || ''} onChange={handleEntityChange}>
                    <option value="" disabled>Select a Currency</option>
                    {currencies.map((currency) => (
                        <option key={currency} value={currency}>
                            {currency}
                        </option>
                    ))}
                </select>
                <button onClick={handleNext} disabled={!selectedCurrency}>Next</button>
            </div>
        </div>
    );
}

export default CurrencyPage;
